export default __webpack_public_path__ + "static/media/screen3.014ddef8.png";